import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  FlatList,
  Modal,
  TextInput,
  ActivityIndicator,
  RefreshControl,
  Alert,
  Dimensions,
  Image,
} from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { MaterialCommunityIcons, Ionicons } from '@expo/vector-icons';
import { useFocusEffect } from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';
const API_BASE_URL = 'https://api.jobeng.ai';
import axios from 'axios';
// expo-print renders the contract HTML into a real PDF, expo-sharing opens
// the system share sheet so the recruiter can email/save/AirDrop it. Both
// already in package.json (verified earlier when we added offer-letter PDF).
import * as Print from 'expo-print';
import * as Sharing from 'expo-sharing';
const api = axios.create({ baseURL: API_BASE_URL, timeout: 15000, headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-API-Key': '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef' } });
api.interceptors.request.use(async c => { try { const t = await AsyncStorage.getItem('auth_token'); if (t) c.headers.Authorization = 'Bearer ' + t; const bid = await AsyncStorage.getItem('company_id'); if (bid) c.params = { ...c.params, company_id: parseInt(bid) }; } catch {} return c; }, e => Promise.reject(e));
const safeData = r => {
  if (!r) return [];
  const body = r.data ?? r;
  if (Array.isArray(body)) return body;
  if (Array.isArray(body?.data)) return body.data;
  if (Array.isArray(body?.rows)) return body.rows;
  if (Array.isArray(body?.results)) return body.results;
  if (Array.isArray(body?.offers)) return body.offers;
  return [];
};
const API_ENDPOINTS = { offers: API_BASE_URL + '/api/recruitment/offers', offersRaw: API_BASE_URL + '/api/data/job_offers', applications: API_BASE_URL + '/api/data/applications', employees: API_BASE_URL + '/api/data/employees', companyProfile: API_BASE_URL + '/api/data/company_profiles', respondOffer: API_BASE_URL + '/api/recruitment/offers' };
const { width, height } = Dimensions.get('window');

export default function AcceptedOffersPipelineScreen({ navigation, route }) {
  const jobId = route?.params?.jobId || null;
  const jobTitle = route?.params?.jobTitle || '';
  const [companyLogo, setCompanyLogo] = useState(route?.params?.companyLogo || null);
  const [companyName, setCompanyName] = useState(route?.params?.companyName || '');
  const [companyId, setCompanyId] = useState(null);
  const [applicants, setApplicants] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [selectedTab, setSelectedTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('start_date');
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [selectedApplicant, setSelectedApplicant] = useState(null);

  // Success milestones
  const successMilestones = [
    {
      id: 'offer_accepted',
      name: 'Offer Accepted',
      description: 'Applicant has accepted the job offer',
      icon: 'check-circle',
      color: '#10B981',
      completed: true,
    },
    {
      id: 'contract_signed',
      name: 'Contract Signed',
      description: 'Employment contract has been digitally signed',
      icon: 'file-document-check',
      color: '#8B5CF6',
      completed: true,
    },
    {
      id: 'background_cleared',
      name: 'Background Check Cleared',
      description: 'Background verification completed successfully',
      icon: 'shield-check',
      color: '#3B82F6',
      completed: true,
    },
    {
      id: 'onboarding_scheduled',
      name: 'Onboarding Scheduled',
      description: 'First day and onboarding process scheduled',
      icon: 'calendar-check',
      color: '#F59E0B',
      completed: false,
    },
    {
      id: 'equipment_ordered',
      name: 'Equipment Ordered',
      description: 'Laptop, phone, and other equipment ordered',
      icon: 'laptop',
      color: '#EF4444',
      completed: false,
    },
  ];

  // Mock applicant data - 8 accepted offer applicants
  const generateMockApplicants = () => {
    const names = [
      'Sarah Johnson', 'Michael Chen', 'Emma Williams', 'James Rodriguez', 
      'Olivia Brown', 'David Kim', 'Sophie Taylor', 'Alexander Davis',
    ];

    const positions = [
      'Senior Software Engineer', 'Product Manager', 'UX Designer', 'Data Scientist',
      'DevOps Engineer', 'Frontend Developer', 'Backend Developer', 'Full Stack Developer',
    ];

    const companies = [
      'Google', 'Microsoft', 'Amazon', 'Apple', 'Meta', 'Netflix', 'Spotify', 'Uber',
    ];

    const locations = [
      'London, UK', 'Manchester, UK', 'Birmingham, UK', 'Edinburgh, UK', 
      'Bristol, UK', 'Leeds, UK', 'Glasgow, UK', 'Liverpool, UK',
    ];

    const skills = [
      'React', 'Node.js', 'Python', 'Java', 'TypeScript', 'AWS', 'Docker', 'Kubernetes',
      'Machine Learning', 'Data Analysis', 'UI/UX Design', 'Project Management',
      'Agile', 'Scrum', 'Leadership', 'Communication', 'Problem Solving', 'Teamwork',
    ];

    const acceptanceStatuses = ['accepted', 'contract_signed', 'background_cleared', 'onboarding_ready', 'pre_boarding'];
    const departments = [
      'Engineering', 'Product', 'Design', 'Data Science', 'DevOps', 'QA',
      'Business', 'Marketing',
    ];

    const mockApplicants = [];
    
    for (let i = 1; i <= 8; i++) {
      const name = names[i - 1];
      const position = positions[Math.floor(Math.random() * positions.length)];
      const company = companies[Math.floor(Math.random() * companies.length)];
      const location = locations[Math.floor(Math.random() * locations.length)];
      const acceptanceStatus = acceptanceStatuses[Math.floor(Math.random() * acceptanceStatuses.length)];
      const department = departments[Math.floor(Math.random() * departments.length)];
      
      const applicantSkills = [];
      const numSkills = Math.floor(Math.random() * 6) + 5; // 5-10 skills
      for (let j = 0; j < numSkills; j++) {
        const skill = skills[Math.floor(Math.random() * skills.length)];
        if (!applicantSkills.includes(skill)) {
          applicantSkills.push(skill);
        }
      }

      // Generate high-level compensation details (accepted offers)
      const baseSalary = Math.floor(Math.random() * 50000) + 80000; // £80k-£130k
      const bonus = Math.floor(baseSalary * (Math.random() * 0.3 + 0.15)); // 15-45% bonus
      const stockOptions = Math.floor(Math.random() * 60000) + 15000; // £15k-£75k
      const totalPackage = baseSalary + bonus + stockOptions;
      
      // Generate acceptance and success metrics
      const acceptanceScore = 100; // All accepted
      const successProbability = Math.floor(Math.random() * 20) + 80; // 80-100%
      const onboardingReadiness = Math.floor(Math.random() * 30) + 70; // 70-100%
      const retentionProbability = Math.floor(Math.random() * 25) + 75; // 75-100%

      // Generate important dates
      const acceptanceDate = new Date();
      acceptanceDate.setDate(acceptanceDate.getDate() - Math.floor(Math.random() * 14)); // Last 2 weeks
      const contractSignedDate = new Date(acceptanceDate);
      contractSignedDate.setDate(contractSignedDate.getDate() + Math.floor(Math.random() * 3) + 1); // 1-4 days after acceptance
      const startDate = new Date();
      startDate.setDate(startDate.getDate() + Math.floor(Math.random() * 45) + 7); // 1-7 weeks from now
      const onboardingDate = new Date(startDate);
      onboardingDate.setDate(onboardingDate.getDate() - 1); // Day before start

      // Generate success milestones completion
      const milestonesCompleted = Math.floor(Math.random() * 3) + 2; // 2-4 milestones completed
      const completedMilestones = successMilestones.slice(0, milestonesCompleted).map(m => m.id);

      // Generate onboarding details
      const onboardingBuddy = [
        'Alice Cooper', 'Bob Smith', 'Carol Johnson', 'David Wilson', 
        'Eva Martinez', 'Frank Brown', 'Grace Lee', 'Henry Davis',
      ][Math.floor(Math.random() * 8)];

      const onboardingManager = [
        'John Manager', 'Sarah Director', 'Mike Lead', 'Lisa Senior',
        'Tom Principal', 'Anna VP', 'Chris Head', 'Emma Chief',
      ][Math.floor(Math.random() * 8)];

      // Generate equipment and setup details
      const equipmentPackage = [
        'MacBook Pro 16"', 'Dell XPS 15', 'ThinkPad X1 Carbon', 'Surface Laptop',
      ][Math.floor(Math.random() * 4)];

      const workSetup = ['Remote', 'Hybrid', 'Office'][Math.floor(Math.random() * 3)];
      const deskLocation = workSetup !== 'Remote' ? 
        ['Floor 3 - Desk 42', 'Floor 2 - Desk 18', 'Floor 4 - Desk 31', 'Floor 1 - Desk 07'][Math.floor(Math.random() * 4)] : 
        'Remote Work';

      // Generate benefits enrollment
      const benefitsEnrolled = Math.random() > 0.3;
      const healthInsurance = Math.random() > 0.2;
      const pensionEnrolled = Math.random() > 0.1;
      const gymMembership = Math.random() > 0.5;

      // Generate pre-boarding activities
      const preBoardingActivities = [
        {
          id: 'welcome_email',
          name: 'Welcome Email Sent',
          completed: Math.random() > 0.1,
          date: new Date(Date.now() - Math.random() * 7 * 24 * 60 * 60 * 1000).toISOString(),
        },
        {
          id: 'team_introduction',
          name: 'Team Introduction Call',
          completed: Math.random() > 0.3,
          date: new Date(Date.now() + Math.random() * 7 * 24 * 60 * 60 * 1000).toISOString(),
        },
        {
          id: 'equipment_setup',
          name: 'Equipment Setup Guide',
          completed: Math.random() > 0.4,
          date: new Date(Date.now() + Math.random() * 5 * 24 * 60 * 60 * 1000).toISOString(),
        },
        {
          id: 'first_day_agenda',
          name: 'First Day Agenda',
          completed: Math.random() > 0.2,
          date: new Date(startDate.getTime() - 24 * 60 * 60 * 1000).toISOString(),
        },
      ];

      // Generate success factors
      const successFactors = [];
      if (successProbability >= 90) successFactors.push('High Success Probability');
      if (retentionProbability >= 85) successFactors.push('High Retention Probability');
      if (onboardingReadiness >= 85) successFactors.push('Onboarding Ready');
      if (totalPackage >= 120000) successFactors.push('Premium Package');
      if (milestonesCompleted >= 3) successFactors.push('Milestones Complete');

      // Generate communication history
      const communicationHistory = [
        {
          date: acceptanceDate.toISOString(),
          type: 'Offer Acceptance',
          message: 'Applicant accepted the job offer with enthusiasm',
          sender: 'Applicant',
        },
        {
          date: contractSignedDate.toISOString(),
          type: 'Contract Signed',
          message: 'Employment contract digitally signed via smart contract',
          sender: 'System',
        },
        {
          date: new Date(Date.now() - Math.random() * 5 * 24 * 60 * 60 * 1000).toISOString(),
          type: 'Welcome Call',
          message: 'Welcome call completed with HR team',
          sender: 'HR',
        },
      ];

      mockApplicants.push({
        id: `applicant_${i}`,
        name: name,
        email: `${name.toLowerCase().replace(' ', '.')}@email.com`,
        phone: `+44 ${Math.floor(Math.random() * 9000) + 1000} ${Math.floor(Math.random() * 900000) + 100000}`,
        position: position,
        currentCompany: company,
        location: location,
        department: department,
        experience: Math.floor(Math.random() * 10) + 8, // 8-18 years (very senior)
        education: ['Master\'s', 'PhD', 'MBA'][Math.floor(Math.random() * 3)],
        skills: applicantSkills,
        
        // Acceptance details
        acceptanceStatus: acceptanceStatus,
        acceptanceDate: acceptanceDate.toISOString(),
        contractSignedDate: contractSignedDate.toISOString(),
        startDate: startDate.toISOString(),
        onboardingDate: onboardingDate.toISOString(),
        
        // Compensation package
        baseSalary: baseSalary,
        bonus: bonus,
        stockOptions: stockOptions,
        totalPackage: totalPackage,
        
        // Success metrics
        acceptanceScore: acceptanceScore,
        successProbability: successProbability,
        onboardingReadiness: onboardingReadiness,
        retentionProbability: retentionProbability,
        
        // Success milestones
        completedMilestones: completedMilestones,
        milestonesCompleted: milestonesCompleted,
        totalMilestones: successMilestones.length,
        
        // Onboarding details
        onboardingBuddy: onboardingBuddy,
        onboardingManager: onboardingManager,
        workSetup: workSetup,
        deskLocation: deskLocation,
        
        // Equipment and setup
        equipmentPackage: equipmentPackage,
        equipmentOrdered: Math.random() > 0.3,
        equipmentDelivered: Math.random() > 0.6,
        accountsCreated: Math.random() > 0.2,
        accessGranted: Math.random() > 0.4,
        
        // Benefits enrollment
        benefitsEnrolled: benefitsEnrolled,
        healthInsurance: healthInsurance,
        pensionEnrolled: pensionEnrolled,
        gymMembership: gymMembership,
        
        // Pre-boarding activities
        preBoardingActivities: preBoardingActivities,
        preBoardingCompleted: preBoardingActivities.filter(a => a.completed).length,
        
        // Background check details
        backgroundCheckStatus: ['Completed', 'In Progress', 'Pending'][Math.floor(Math.random() * 3)],
        backgroundCheckDate: new Date(Date.now() - Math.random() * 10 * 24 * 60 * 60 * 1000).toISOString(),
        referencesVerified: Math.random() > 0.2,
        criminalCheckClear: Math.random() > 0.05,
        educationVerified: Math.random() > 0.1,
        
        // Smart contract details
        smartContractAddress: `0x${Math.random().toString(16).substr(2, 40)}`,
        contractVersion: `v${Math.floor(Math.random() * 3) + 2}.${Math.floor(Math.random() * 10)}`,
        blockchainVerified: true,
        digitalSignatureValid: true,
        
        // Communication tracking
        communicationHistory: communicationHistory,
        lastContact: new Date(Date.now() - Math.random() * 3 * 24 * 60 * 60 * 1000).toISOString(),
        responseTime: Math.floor(Math.random() * 24) + 1, // 1-24 hours
        communicationScore: Math.floor(Math.random() * 20) + 80, // 80-100%
        
        // Previous performance summary
        finalInterviewScore: Math.floor(Math.random() * 10) + 90, // 90-100
        arDemoScore: Math.floor(Math.random() * 10) + 90, // 90-100
        overallRating: Math.floor(Math.random() * 1) + 4, // 4-5 stars
        executiveRecommendation: true,
        
        // Success factors
        successFactors: successFactors,
        
        // Risk assessment
        riskFactors: (() => {
          const risks = [];
          if (successProbability < 85) risks.push('Lower Success Probability');
          if (onboardingReadiness < 80) risks.push('Onboarding Preparation');
          if (retentionProbability < 80) risks.push('Retention Risk');
          if (milestonesCompleted < 3) risks.push('Incomplete Milestones');
          return risks;
        })(),
        
        // Days until start
        daysUntilStart: Math.ceil((new Date(startDate) - new Date()) / (1000 * 60 * 60 * 24)),
        
        // Onboarding preparation score
        onboardingPreparationScore: Math.floor(
          (preBoardingActivities.filter(a => a.completed).length / preBoardingActivities.length) * 100
        ),
        
        // Tags based on status and performance
        tags: (() => {
          const baseTags = ['Success'];
          if (acceptanceStatus === 'onboarding_ready') baseTags.push('Onboarding Ready');
          if (milestonesCompleted >= 4) baseTags.push('All Milestones');
          if (successProbability >= 95) baseTags.push('High Success');
          if (totalPackage >= 130000) baseTags.push('Premium Hire');
          return baseTags;
        })(),
        
        avatar: `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random`,
        lastActivity: new Date(Date.now() - Math.random() * 12 * 60 * 60 * 1000).toISOString(),
      });
    }

    return mockApplicants.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
  };

  // Tab badge counts derived from the real applicants array. Was previously
  // hardcoded ({count: 8}, {count: 2}, etc.) so the badges showed lies as
  // soon as anything loaded. Recomputes when applicants changes so the
  // numbers stay in sync — including after Move-to-Hired drops a row out.
  const tabs = React.useMemo(() => {
    const byStatus = (s) => applicants.filter(a => a.acceptanceStatus === s).length;
    return [
      { id: 'all',                 name: 'All',                count: applicants.length              },
      { id: 'accepted',            name: 'Accepted',           count: byStatus('accepted')           },
      { id: 'contract_sent',       name: 'Contract Sent',      count: byStatus('contract_sent')      },
      { id: 'contract_signed',     name: 'Contract Signed',    count: byStatus('contract_signed')    },
      { id: 'background_cleared',  name: 'Background Cleared', count: byStatus('background_cleared') },
      { id: 'onboarding_ready',    name: 'Onboarding Ready',   count: byStatus('onboarding_ready')   },
    ];
  }, [applicants]);

  const sortOptions = [
    { id: 'start_date', name: 'Start Date', icon: 'calendar-start' },
    { id: 'acceptance_date', name: 'Acceptance Date', icon: 'calendar-check' },
    { id: 'success_probability', name: 'Success Probability', icon: 'trending-up' },
    { id: 'name', name: 'Name', icon: 'account' },
    { id: 'package_value', name: 'Package Value', icon: 'currency-gbp' },
  ];

  useEffect(() => {
    loadApplicants();
  }, []);

    useFocusEffect(React.useCallback(() => { loadCompanyLogo(); }, []));
  const loadCompanyLogo = async () => {
    try {
      const cachedProfile = await AsyncStorage.getItem('company_profile');
      if (cachedProfile) { const profile = JSON.parse(cachedProfile); setCompanyLogo(profile.logo || null); if (profile.name || profile.company_name) setCompanyName(profile.name || profile.company_name); }
      const cid = await AsyncStorage.getItem('company_id');
      if (cid) {
        setCompanyId(cid);
        const response = await api.get(API_ENDPOINTS.companyProfile, { params: { company_id: cid } });
        if (response.data?.success && response.data.data?.length > 0) {
          const lp = response.data.data[0]; setCompanyLogo(lp.logo || null);
          if (lp.name || lp.company_name) setCompanyName(lp.name || lp.company_name);
          await AsyncStorage.setItem('company_profile', JSON.stringify(lp));
        }
      }
    } catch (e) { console.warn('Logo load error:', e.message); }
  };

const loadApplicants = async () => {
    setIsLoading(true);
    try {
      // Never silently default to company 1 — the original `|| '1'` here was a
      // cross-company data-leak risk. If we don't know the company, show empty.
      const cid = companyId || parseInt(await AsyncStorage.getItem('company_id') || '0', 10);
      if (!cid) {
        setApplicants([]);
        setIsLoading(false);
        setRefreshing(false);
        return;
      }
      // /api/recruitment/offers returns job_offers JOINed with applications +
      // users + jobs, so every row carries real candidate_name (from users.full_name),
      // job_title (from jobs JOIN), and employer_name. No more "Unknown".
      // FALLBACK: the recruitment endpoint has been returning 500 intermittently
      // (server-side bug). When that happens, retry against /api/data/job_offers
      // which is the generic data handler — same columns minus the JOINed
      // niceties (job_title, employer_logo). Better to show real candidate
      // data than to render an empty screen.
      let apiData = [];
      try {
        const response = await api.get(API_ENDPOINTS.offers, { params: { company_id: cid, limit: 500 } });
        apiData = safeData(response);
        console.log('[AcceptedOffers] /api/recruitment/offers returned', apiData.length, 'rows');
      } catch (e) {
        const status = e?.response?.status;
        console.warn('[AcceptedOffers] /api/recruitment/offers failed', status, '— falling back to /api/data/job_offers');
        const response2 = await api.get(API_ENDPOINTS.offersRaw, { params: { company_id: cid, limit: 500 } });
        apiData = safeData(response2);
        console.log('[AcceptedOffers] /api/data/job_offers fallback returned', apiData.length, 'rows');
      }
      const accepted = apiData.filter(o => (o.status || '').toLowerCase() === 'accepted');

      const mapped = accepted.map(o => {
        // Derive the contract/onboarding pipeline stage from the real
        // DB flags. The tab system filters by this — without it every
        // row would just live under "All" and the per-stage tabs would
        // show zero. Priority: most-advanced state wins.
        let acceptanceStatus = 'accepted';
        const bgStatus = String(o.background_check_status || '').toLowerCase();
        if (o.onboarding_ready)                                   acceptanceStatus = 'onboarding_ready';
        else if (bgStatus === 'cleared' || bgStatus === 'passed') acceptanceStatus = 'background_cleared';
        else if (o.contract_signed)                               acceptanceStatus = 'contract_signed';
        else if (o.contract_sent)                                 acceptanceStatus = 'contract_sent';
        // else stays 'accepted' — just accepted, no contract action yet

        return {
        id: String(o.id),
        applicationId: o.application_id,
        // Prefer the JOINed candidate name; fall back through the chain.
        // Never default to "Unknown" — that's just hiding a data issue.
        name: o.candidate_name || 'Applicant',
        email: o.candidate_email || '',
        phone: o.candidate_phone || '',
        avatar: o.candidate_avatar || null,
        position: o.position || o.job_title || '',
        department: o.department || '',
        salary: o.salary || '',
        salaryCurrency: o.salary_currency || 'GBP',
        bonus: o.bonus || 0,
        start_date: o.start_date || null,
        location: o.candidate_location || o.job_location || '',
        work_type: o.work_type || 'Hybrid',
        contract_type: o.contract_type || 'Permanent',
        status: 'accepted',
        // Pipeline-stage flag drives the tabs and the status badge
        acceptanceStatus,
        // Real timestamps from the offer row
        offer_accepted_date: o.accepted_date || o.accepted_at || o.updated_at || o.created_at || null,
        contract_sent_date:  o.contract_sent_date || null,
        contract_signed_date: o.contract_signed_date || null,
        background_check_status: o.background_check_status || null,
        onboarding_date: o.onboarding_date || null,
        milestones: {
          offer_accepted:    !!(o.accepted_date || o.accepted_at),
          contract_sent:     !!o.contract_sent,
          contract_signed:   !!o.contract_signed,
          background_check:  bgStatus === 'cleared' || bgStatus === 'passed',
          onboarding_ready:  !!o.onboarding_ready,
        },
        interviewScore: o.interview_score ?? null,
        experience: o.experience || '',
        notes: o.notes || o.response_message || '',
        employerName: o.employer_name || '',
        employerLogo: o.employer_logo || null,
        jobId: o.job_id,
        jobTitle: o.job_title || '',
        // Pass through the candidate's user_id and benefits string for the
        // contract PDF builder.
        candidateUserId: o.user_id || null,
        deadline: o.deadline || null,
        benefits: o.benefits || '',
        probation_period: o.probation_period || '6 months',
        notice_period: o.notice_period || '1 month',
        working_hours: o.working_hours || '37.5',
        raw: o,
      }; });
      setApplicants(mapped);
      await AsyncStorage.setItem('accepted_offers', JSON.stringify(mapped)).catch(() => {});
    } catch (e) {
      console.warn('loadApplicants:', e?.message);
      // Offline cache fallback only — empty state if no cache, NEVER mock data
      try {
        const cached = await AsyncStorage.getItem('accepted_offers');
        if (cached) setApplicants(JSON.parse(cached));
        else setApplicants([]);
      } catch { setApplicants([]); }
    } finally {
      setIsLoading(false);
      setRefreshing(false);
    }
  };

  const onRefresh = async () => {
    setRefreshing(true);
    await loadApplicants();
    setRefreshing(false);
  };

  const filteredApplicants = applicants.filter(applicant => {
    const matchesTab = selectedTab === 'all' || applicant.acceptanceStatus === selectedTab;
    
    const matchesSearch = (applicant.name || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                         (applicant.position || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                         (applicant.currentCompany || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                         (applicant.department || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                         (applicant.onboardingBuddy || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                         (applicant.onboardingManager || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                         (applicant.skills || []).some(skill => (skill || '').toLowerCase().includes(searchQuery.toLowerCase()));
    return matchesTab && matchesSearch;
  });

  const sortedApplicants = [...filteredApplicants].sort((a, b) => {
    switch (sortBy) {
      case 'start_date':
        return new Date(a.startDate) - new Date(b.startDate);
      case 'acceptance_date':
        return new Date(b.acceptanceDate) - new Date(a.acceptanceDate);
      case 'success_probability':
        return b.successProbability - a.successProbability;
      case 'name':
        return a.name.localeCompare(b.name);
      case 'package_value':
        return b.totalPackage - a.totalPackage;
      default:
        return 0;
    }
  });

  const getAcceptanceStatusColor = (status) => {
    switch (status) {
      case 'accepted': return '#10B981';
      case 'contract_signed': return '#8B5CF6';
      case 'background_cleared': return '#3B82F6';
      case 'onboarding_ready': return '#F59E0B';
      case 'pre_boarding': return '#EF4444';
      default: return '#6B7280';
    }
  };

  const getAcceptanceStatusText = (status) => {
    switch (status) {
      case 'accepted': return 'ACCEPTED';
      case 'contract_signed': return 'CONTRACT SIGNED';
      case 'background_cleared': return 'BACKGROUND CLEARED';
      case 'onboarding_ready': return 'ONBOARDING READY';
      case 'pre_boarding': return 'PRE-BOARDING';
      default: return (status || 'accepted').toUpperCase();
    }
  };

  const getSuccessProbabilityColor = (probability) => {
    if (probability >= 90) return '#10B981';
    if (probability >= 80) return '#F59E0B';
    return '#EF4444';
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };

  const getDaysUntilStart = (startDateString) => {
    const startDate = new Date(startDateString);
    const today = new Date();
    const diffTime = startDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <MaterialCommunityIcons
          key={i}
          name={i <= rating ? 'star' : 'star-outline'}
          size={14}
          color={i <= rating ? '#F59E0B' : '#D1D5DB'}
        />
      );
    }
    return stars;
  };

  const handleApplicantPress = (applicant) => {
    navigation.navigate('AcceptedOfferDetailsScreen', { applicant, companyLogo, companyName });
  };

  const handleSelectApplicant = (applicantId) => {
    setSelectedApplicants(prev => {
      if (prev.includes(applicantId)) {
        return prev.filter(id => id !== applicantId);
      } else {
        return [...prev, applicantId];
      }
    });
  };

  // ═════════════════════════════════════════════════════════════════════════
  // CONTRACT MANAGEMENT
  // Builds a formal HTML employment contract from the applicant/offer data,
  // renders it to PDF via expo-print, and either previews it or fires the
  // send workflow (PDF share + DB write that flips contract_sent=true).
  // ═════════════════════════════════════════════════════════════════════════
  const buildContractHTML = (applicant) => {
    const fmt = (iso) => {
      if (!iso) return 'To be confirmed';
      try { return new Date(iso).toLocaleDateString('en-GB', { day:'numeric', month:'long', year:'numeric' }); }
      catch { return String(iso); }
    };
    const today = new Date().toLocaleDateString('en-GB', { day:'numeric', month:'long', year:'numeric' });
    const safe = (s) => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    const benefits = Array.isArray(applicant.benefits)
      ? applicant.benefits
      : (typeof applicant.benefits === 'string' && applicant.benefits.trim()
          ? applicant.benefits.split(/[\n,;]+/).map(s => s.trim()).filter(Boolean)
          : []);
    const employer = applicant.employerName || 'The Company';
    const salaryFmt = applicant.salary
      ? `${applicant.salaryCurrency === 'GBP' ? '£' : applicant.salaryCurrency + ' '}${Number(applicant.salary).toLocaleString()}`
      : 'To be discussed';
    const logoBlock = applicant.employerLogo
      ? `<img src="${safe(applicant.employerLogo)}" alt="logo" style="height:60px;max-width:200px;object-fit:contain"/>`
      : `<div style="font-size:24px;font-weight:700;color:#0e4e96">${safe(employer)}</div>`;

    return `<!DOCTYPE html>
<html><head><meta charset="utf-8"/>
<style>
  @page { margin: 26mm 22mm; }
  body { font-family: -apple-system, "Helvetica Neue", Helvetica, Arial, sans-serif; color:#1e293b; line-height:1.55; font-size:10.5pt; }
  .header { display:flex; align-items:center; justify-content:space-between; border-bottom:2px solid #0e4e96; padding-bottom:14px; margin-bottom:24px; }
  .meta { text-align:right; font-size:9pt; color:#64748b; }
  .title { color:#0e4e96; font-size:18pt; font-weight:700; margin:18px 0 4px 0; letter-spacing:-0.3px; text-align:center; }
  .subtitle { color:#64748b; font-size:10pt; margin-bottom:24px; text-align:center; }
  h2 { color:#0e4e96; font-size:11.5pt; margin:20px 0 6px 0; padding-bottom:3px; border-bottom:1px solid #e2e8f0; }
  table.terms { width:100%; border-collapse:collapse; margin-bottom:6px; }
  table.terms td { padding:5px 0; vertical-align:top; }
  table.terms td:first-child { color:#64748b; font-weight:500; width:35%; }
  table.terms td:last-child  { color:#1e293b; font-weight:600; }
  .clause { margin:10px 0; }
  .clause-num { color:#0e4e96; font-weight:600; }
  ul { padding-left:18px; margin:4px 0; }
  ul li { padding:1px 0; }
  .signature { margin-top:36px; display:flex; gap:50px; }
  .sig-block { flex:1; }
  .sig-line { border-top:1px solid #94a3b8; margin-top:44px; padding-top:5px; font-size:9pt; color:#64748b; }
  .footer { margin-top:34px; padding-top:12px; border-top:1px solid #e2e8f0; font-size:8.5pt; color:#94a3b8; text-align:center; }
  .accent { color:#0e4e96; font-weight:600; }
</style></head>
<body>
  <div class="header">
    ${logoBlock}
    <div class="meta">
      <div><strong>${safe(employer)}</strong></div>
      <div>Issued: ${today}</div>
      <div>Reference: CONTRACT-${safe(applicant.id || 'XXX')}</div>
    </div>
  </div>

  <div class="title">Contract of Employment</div>
  <div class="subtitle">between ${safe(employer)} and ${safe(applicant.name)}</div>

  <p>This contract of employment is entered into on <span class="accent">${today}</span> between
  <span class="accent">${safe(employer)}</span> ("the Employer") and <span class="accent">${safe(applicant.name)}</span> ("the Employee").</p>

  <h2>1. Position &amp; Duties</h2>
  <table class="terms">
    <tr><td>Position</td><td>${safe(applicant.position)}</td></tr>
    ${applicant.department ? `<tr><td>Department</td><td>${safe(applicant.department)}</td></tr>` : ''}
    <tr><td>Reporting location</td><td>${safe(applicant.location)}</td></tr>
    <tr><td>Work arrangement</td><td>${safe(applicant.work_type)}</td></tr>
    <tr><td>Contract type</td><td>${safe(applicant.contract_type)}</td></tr>
  </table>

  <h2>2. Commencement &amp; Probation</h2>
  <table class="terms">
    <tr><td>Start date</td><td>${safe(fmt(applicant.start_date))}</td></tr>
    <tr><td>Probation period</td><td>${safe(applicant.probation_period)}</td></tr>
  </table>
  <p class="clause">During the probation period, either party may terminate this contract with one (1) week's written notice.</p>

  <h2>3. Hours of Work</h2>
  <p class="clause">The Employee's normal working hours shall be <span class="accent">${safe(applicant.working_hours)}</span> hours per week, exclusive of meal breaks, on such days and at such times as the Employer reasonably requires.</p>

  <h2>4. Compensation</h2>
  <table class="terms">
    <tr><td>Annual base salary</td><td>${salaryFmt}</td></tr>
    <tr><td>Pay frequency</td><td>Monthly, on the last working day</td></tr>
    <tr><td>Pension</td><td>Auto-enrolment per UK legislation</td></tr>
  </table>

  ${benefits.length ? `<h2>5. Benefits</h2>
  <ul>
    ${benefits.map(b => `<li>${safe(b)}</li>`).join('')}
  </ul>` : ''}

  <h2>${benefits.length ? '6' : '5'}. Holiday Entitlement</h2>
  <p class="clause">The Employee shall be entitled to 25 working days of paid holiday per annum (pro-rata), in addition to UK public holidays. The holiday year runs from 1 January to 31 December.</p>

  <h2>${benefits.length ? '7' : '6'}. Notice Period</h2>
  <p class="clause">After successful completion of the probationary period, either party may terminate this contract by giving <span class="accent">${safe(applicant.notice_period)}</span> written notice, save where summary dismissal is justified.</p>

  <h2>${benefits.length ? '8' : '7'}. Confidentiality &amp; IP</h2>
  <p class="clause">The Employee agrees not to disclose, during or after employment, any confidential information of the Employer. All work product, inventions, and intellectual property created in the course of employment shall vest absolutely in the Employer.</p>

  <h2>${benefits.length ? '9' : '8'}. Governing Law</h2>
  <p class="clause">This contract shall be governed by and construed in accordance with the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.</p>

  <h2>${benefits.length ? '10' : '9'}. Acceptance</h2>
  <p class="clause">By signing below, the Employee confirms acceptance of the terms of this contract and agrees to commence employment on the start date stated above.</p>

  <div class="signature">
    <div class="sig-block">
      <div class="sig-line">For and on behalf of ${safe(employer)} (Employer)</div>
    </div>
    <div class="sig-block">
      <div class="sig-line">Signed: ${safe(applicant.name)} (Employee)</div>
    </div>
  </div>

  <div class="footer">
    This document was generated by JobEng on ${today}. Contract reference: CONTRACT-${safe(applicant.id || 'XXX')}.
  </div>
</body></html>`;
  };

  // Preview the contract WITHOUT marking it as sent — useful for reviewing
  // terms before committing to delivery.
  const previewContract = async (applicant) => {
    try {
      const html = buildContractHTML(applicant);
      const { uri } = await Print.printToFileAsync({ html, base64: false });
      const canShare = await Sharing.isAvailableAsync().catch(() => false);
      if (canShare) {
        await Sharing.shareAsync(uri, {
          mimeType: 'application/pdf',
          dialogTitle: `Contract Preview — ${applicant.name}`,
          UTI: 'com.adobe.pdf',
        });
      } else {
        await Print.printAsync({ html });
      }
    } catch (e) {
      console.warn('previewContract:', e?.message);
      Alert.alert('Preview failed', e?.message || 'Could not render the contract PDF.');
    }
  };

  // Send contract: generate PDF, open share sheet, AND mark contract_sent=true
  // in the DB so the card moves into the "Contract Sent" tab.
  const sendContract = async (applicant) => {
    if (!applicant?.id || String(applicant.id).startsWith('mock_')) {
      Alert.alert('Cannot send', 'This is a sample row — no database id to update.');
      return;
    }
    Alert.alert(
      'Send Contract',
      `Generate and send the employment contract to ${applicant.name}?\n\nA PDF will open in the share sheet so you can email/AirDrop it. The candidate will move to the "Contract Sent" tab.`,
      [
        { text: 'Cancel', style: 'cancel' },
        {
          text: 'Generate & Send',
          onPress: async () => {
            const nowIso = new Date().toISOString();

            // 1. Render and share the PDF
            try {
              const html = buildContractHTML(applicant);
              const { uri } = await Print.printToFileAsync({ html, base64: false });
              const canShare = await Sharing.isAvailableAsync().catch(() => false);
              if (canShare) {
                await Sharing.shareAsync(uri, {
                  mimeType: 'application/pdf',
                  dialogTitle: `Employment Contract — ${applicant.name}`,
                  UTI: 'com.adobe.pdf',
                });
              } else {
                await Print.printAsync({ html });
              }
            } catch (e) {
              console.warn('sendContract PDF:', e?.message);
              Alert.alert('Share failed', e?.message || 'Could not generate the contract PDF.');
              return;
            }

            // 2. Mark contract_sent=true in DB. Routed to /api/data/job_offers
            //    (offersRaw) because /api/recruitment/offers is currently
            //    server-side broken (5xx). Confirm the write so we don't
            //    silently move the UI forward on failure.
            let dbWriteOk = false;
            try {
              const resp = await api.put(API_ENDPOINTS.offersRaw + '/' + applicant.id, {
                contract_sent: true,
                contract_sent_date: nowIso,
              });
              dbWriteOk = !!(resp && resp.status >= 200 && resp.status < 300);
              console.log('[AcceptedOffers] sendContract PUT status:', resp?.status, 'data:', resp?.data);
            } catch (e) {
              console.warn('[AcceptedOffers] sendContract DB PUT failed:', e?.response?.status, e?.response?.data || e?.message);
            }
            if (!dbWriteOk) {
              Alert.alert(
                'Contract sent locally',
                "The PDF was generated and shared, but the database write failed. The card has not been moved server-side — refresh and try again, or check the server log.",
              );
              return;
            }

            // 3. Bump applicant stage so the recruitment pipeline reflects it
            if (applicant.applicationId) {
              try {
                await api.post(`${API_BASE_URL}/api/recruitment/applicant/${applicant.applicationId}/stage`, {
                  stage:  'contract_sent',
                  status: 'contract_sent',
                  note:   `Contract sent to ${applicant.name} for ${applicant.position}`,
                });
              } catch {}
            }

            // 4. Reflect locally so the card moves tabs without a refetch
            const updated = applicants.map(a =>
              a.id === applicant.id
                ? { ...a, acceptanceStatus: 'contract_sent', contract_sent_date: nowIso, milestones: { ...a.milestones, contract_sent: true } }
                : a
            );
            setApplicants(updated);
            await AsyncStorage.setItem('accepted_offers', JSON.stringify(updated)).catch(() => {});

            Alert.alert(
              '✓ Contract Sent',
              `${applicant.name} has been moved to the Contract Sent tab. They'll appear there until you mark the contract as signed.`
            );
          }
        }
      ]
    );
  };

  // Mark contract as signed — final step before background check / onboarding.
  // Typically used after the candidate returns the signed PDF outside the app.
  const markContractSigned = async (applicant) => {
    if (!applicant?.id || String(applicant.id).startsWith('mock_')) {
      Alert.alert('Cannot update', 'This is a sample row — no database id to update.');
      return;
    }
    Alert.alert(
      'Mark Contract Signed',
      `Confirm that ${applicant.name} has signed and returned the employment contract?`,
      [
        { text: 'Cancel', style: 'cancel' },
        {
          text: 'Confirm Signed',
          onPress: async () => {
            const today  = new Date().toISOString().slice(0, 10);
            const nowIso = new Date().toISOString();

            let dbWriteOk = false;
            try {
              const resp = await api.put(API_ENDPOINTS.offersRaw + '/' + applicant.id, {
                contract_signed: true,
                contract_signed_date: nowIso,
              });
              dbWriteOk = !!(resp && resp.status >= 200 && resp.status < 300);
              console.log('[AcceptedOffers] markContractSigned PUT status:', resp?.status, 'data:', resp?.data);
            } catch (e) {
              console.warn('[AcceptedOffers] markContractSigned DB PUT failed:', e?.response?.status, e?.response?.data || e?.message);
            }
            if (!dbWriteOk) {
              Alert.alert(
                'Update failed',
                "Could not save the signed status to the database. The card has not been moved — refresh and try again.",
              );
              return;
            }

            if (applicant.applicationId) {
              try {
                await api.post(`${API_BASE_URL}/api/recruitment/applicant/${applicant.applicationId}/stage`, {
                  stage:  'contract_signed',
                  status: 'contract_signed',
                  note:   `${applicant.name} returned signed contract`,
                });
              } catch {}
            }

            const updated = applicants.map(a =>
              a.id === applicant.id
                ? { ...a, acceptanceStatus: 'contract_signed', contract_signed_date: nowIso, milestones: { ...a.milestones, contract_signed: true } }
                : a
            );
            setApplicants(updated);
            await AsyncStorage.setItem('accepted_offers', JSON.stringify(updated)).catch(() => {});

            Alert.alert('✓ Signed', `${applicant.name}'s contract is on file. Next: background check or onboarding.`);
          }
        }
      ]
    );
  };

  const handleStartOnboarding = (applicant) => {
    Alert.alert(
      'Start Onboarding Process',
      `Start onboarding for ${applicant.name}?\n\nPosition: ${applicant.position}\nStart Date: ${new Date(applicant.startDate).toLocaleDateString('en-GB')}\nBuddy: ${applicant.onboardingBuddy || 'TBA'}`,
      [
        { text: 'Cancel', style: 'cancel' },
        { 
          text: 'Start Onboarding', 
          onPress: async () => {
            try { await api.put(API_ENDPOINTS.offersRaw + '/' + applicant.id, { status: 'onboarding', acceptance_status: 'onboarding_ready' }); } catch (e) { console.warn('Onboarding update failed:', e.message); }
            const updated = applicants.map(a => a.id === applicant.id ? { ...a, acceptanceStatus: 'onboarding_ready' } : a);
            setApplicants(updated);
            await AsyncStorage.setItem('accepted_offers', JSON.stringify(updated));
            Alert.alert('Started', `Onboarding initiated for ${applicant.name}`);
          }
        },
      ]
    );
  };

  // ── Move a single accepted candidate to the Hired stage ──
  // This is the final pipeline transition. Three things happen server-side
  // so every consumer sees consistent state:
  //   1. job_offers.status flips to 'hired' — AcceptedOffersScreen filters
  //      these out (only 'accepted' shows here)
  //   2. applications.stage bumps to 'hired' — pipeline view reflects the
  //      candidate moved out of offers and into the hired bucket
  //   3. An employees row is created if none exists — converts the candidate
  //      from a "promise" (job_offer accepted) into a real employee record
  //      with active status. This is what HiredScreen reads to show its list.
  const handleMoveToHired = (applicant) => {
    Alert.alert(
      'Move to Hired',
      `Mark ${applicant.name} as hired? This will:\n• Update the offer to hired status\n• Bump pipeline stage to hired\n• Create their employee record`,
      [
        { text: 'Cancel', style: 'cancel' },
        {
          text: 'Confirm Hire',
          onPress: async () => {
            const today = new Date().toISOString().slice(0, 10);
            const cid = parseInt(await AsyncStorage.getItem('company_id') || '0', 10) || null;

            // 1. Update job_offers — flag as hired. job_offers has no
            //    hired_date column; status='hired' + onboarding_date is the
            //    accepted convention here.
            try {
              await api.put(API_ENDPOINTS.offersRaw + '/' + applicant.id, {
                status: 'hired',
                acceptance_status: 'hired',
                onboarding_date: today,
              });
            } catch (e) { console.warn('handleMoveToHired: offer update', e?.message); }

            // 2. Bump applicant stage to 'hired'
            if (applicant.applicationId) {
              try {
                await api.post(`${API_BASE_URL}/api/recruitment/applicant/${applicant.applicationId}/stage`, {
                  stage:  'hired',
                  status: 'hired',
                  note:   `${applicant.name} hired — moved from accepted-offer to hired pipeline`,
                });
              } catch (e) { console.warn('handleMoveToHired: stage bump', e?.message); }
            }

            // 3. Create employee record. Real column is `name`, not full_name.
            //    Idempotency depends on the backend de-duping by (email, company_id).
            try {
              await api.post(API_ENDPOINTS.employees, {
                company_id: cid,
                user_id:    applicant.user_id || applicant.userId || null,
                name:       applicant.name,
                email:      applicant.email,
                phone:      applicant.phone || '',
                position:   applicant.position || '',
                department: applicant.department || '',
                salary:     applicant.salary || 0,
                start_date: applicant.start_date || null,
                location:   applicant.location || '',
                work_type:  applicant.work_type || 'Hybrid',
                status:     'active',
                job_offer_id: applicant.id,
              });
            } catch (e) { console.warn('handleMoveToHired: employee create', e?.message); }

            // 4. Reflect locally — remove the applicant from the accepted list
            const updated = applicants.filter(a => a.id !== applicant.id);
            setApplicants(updated);
            await AsyncStorage.setItem('accepted_offers', JSON.stringify(updated));

            Alert.alert(
              'Hired',
              `${applicant.name} moved to the hired pipeline. Their employee record has been created.`,
              [
                {
                  text: 'View Hired',
                  onPress: () => navigation.navigate('HiredPipelineScreen', {
                    focusApplicantId: applicant.applicationId,
                    focusEmployeeEmail: applicant.email,
                    companyLogo, companyName,
                  }),
                },
                { text: 'Stay Here', style: 'cancel' },
              ]
            );
          },
        },
      ]
    );
  };

  const handleScheduleFirstDay = (applicant) => {
    const startDate = applicant.startDate ? new Date(applicant.startDate).toLocaleDateString('en-GB') : 'TBA';
    Alert.alert(
      'Schedule First Day',
      `Schedule first day for ${applicant.name}?\n\nStart Date: ${startDate}\nOnboarding Date: ${applicant.onboardingDate ? new Date(applicant.onboardingDate).toLocaleDateString('en-GB') : 'TBA'}\nLocation: ${applicant.deskLocation || applicant.location || 'TBC'}\nEquipment: ${applicant.equipmentPackage || 'TBC'}\nBuddy: ${applicant.onboardingBuddy || 'TBA'}\nManager: ${applicant.onboardingManager || 'TBA'}`,
      [
        { text: 'Cancel', style: 'cancel' },
        { 
          text: 'Schedule', 
          onPress: async () => {
            try { await api.put(API_ENDPOINTS.offersRaw + '/' + applicant.id, { status: 'onboarding_scheduled' }); } catch (e) { console.warn('Schedule failed:', e.message); }
            Alert.alert('Scheduled', `First day scheduled for ${applicant.name} on ${startDate}`);
          }
        },
        {
          text: 'View Details',
          onPress: () => navigation.navigate('AcceptedOfferDetailsScreen', { applicant, companyLogo, companyName }),
        },
      ]
    );
  };

  const handleBulkAction = (action) => {
    if (selectedApplicants.length === 0) {
      Alert.alert('No Selection', 'Please select applicants first');
      return;
    }

    Alert.alert(
      'Bulk Action',
      `${action} ${selectedApplicants.length} selected applicants?`,
      [
        { text: 'Cancel', style: 'cancel' },
        { 
          text: 'Confirm', 
          onPress: async () => {
            for (const aid of selectedApplicants) {
              try { await api.put(API_ENDPOINTS.offersRaw + '/' + aid, { status: action === 'Move to Hired' ? 'hired' : action === 'Send Welcome' ? 'onboarding_ready' : action.toLowerCase().replace(/\s+/g, '_') }); } catch {}
            }
            const updated = applicants.map(a => selectedApplicants.includes(a.id) ? { ...a, acceptanceStatus: action === 'Move to Hired' ? 'hired' : 'onboarding_ready' } : a);
            setApplicants(updated);
            await AsyncStorage.setItem('accepted_offers', JSON.stringify(updated));
            Alert.alert('Done', `${action} completed for ${selectedApplicants.length} applicants`);
            setSelectedApplicants([]);
            // Move to next pipeline stage
            if (action === 'Move to Hired') {
              navigation.navigate('HiredPipelineScreen', {
                selectedApplicants: selectedApplicants, companyLogo, companyName,
              });
            }
          }
        },
      ]
    );
  };

  const renderApplicantCard = ({ item }) => (
    <TouchableOpacity
      style={[
        styles.applicantCard,
        selectedApplicants.includes(item.id) && styles.selectedCard,
      ]}
      onPress={() => handleApplicantPress(item)}
      activeOpacity={0.7}
    >
      {/* Selection Checkbox */}
      <TouchableOpacity
        style={styles.checkbox}
        onPress={() => handleSelectApplicant(item.id)}
      >
        <MaterialCommunityIcons
          name={selectedApplicants.includes(item.id) ? 'checkbox-marked' : 'checkbox-blank-outline'}
          size={24}
          color={selectedApplicants.includes(item.id) ? '#10B981' : '#D1D5DB'}
        />
      </TouchableOpacity>

      {/* Applicant Header */}
      <View style={styles.applicantHeader}>
        <Image source={{ uri: (item.avatar && item.avatar.startsWith('http')) ? item.avatar : undefined }} style={styles.avatar} />
        <View style={styles.applicantInfo}>
          <View style={styles.applicantNameContainer}>
            <Text style={styles.applicantName}>{item.name}</Text>
            <View style={styles.applicantBadges}>
              {(item.tags || []).map((tag, index) => (
                <View key={index} style={styles.tagBadge}>
                  <MaterialCommunityIcons name="check-circle" size={10} color="#10B981" />
                  <Text style={styles.tagText}>{tag}</Text>
                </View>
              ))}
            </View>
          </View>
          <Text style={styles.applicantPosition}>{item.position}</Text>
          <Text style={styles.applicantCompany}>{item.currentCompany} • {item.department}</Text>
        </View>
        <View style={styles.applicantStatus}>
          <View style={[styles.statusBadge, { backgroundColor: getAcceptanceStatusColor(item.acceptanceStatus) }]}>
            <Text style={styles.statusText}>{getAcceptanceStatusText(item.acceptanceStatus)}</Text>
          </View>
        </View>
      </View>

      {/* Success Metrics Summary */}
      <View style={styles.successMetricsContainer}>
        <View style={styles.successMetricsHeader}>
          <MaterialCommunityIcons name="trending-up" size={20} color="#10B981" />
          <Text style={styles.successMetricsTitle}>Success Metrics</Text>
          <View style={styles.successScoreBadge}>
            <Text style={styles.successScoreText}>{item.successProbability}%</Text>
          </View>
        </View>
        
        {/* Metrics Grid */}
        <View style={styles.metricsGrid}>
          <View style={styles.metricItem}>
            <MaterialCommunityIcons name="check-circle" size={16} color="#10B981" />
            <Text style={styles.metricLabel}>Milestones</Text>
            <Text style={styles.metricValue}>{item.milestonesCompleted}/{item.totalMilestones}</Text>
          </View>
          <View style={styles.metricItem}>
            <MaterialCommunityIcons name="school" size={16} color="#3B82F6" />
            <Text style={styles.metricLabel}>Onboarding</Text>
            <Text style={styles.metricValue}>{item.onboardingReadiness}%</Text>
          </View>
          <View style={styles.metricItem}>
            <MaterialCommunityIcons name="account-heart" size={16} color="#8B5CF6" />
            <Text style={styles.metricLabel}>Retention</Text>
            <Text style={styles.metricValue}>{item.retentionProbability}%</Text>
          </View>
          <View style={styles.metricItem}>
            <MaterialCommunityIcons name="calendar-start" size={16} color="#F59E0B" />
            <Text style={styles.metricLabel}>Days to Start</Text>
            <Text style={[
              styles.metricValue,
              { color: item.daysUntilStart <= 7 ? '#EF4444' : '#374151' }
            ]}>
              {item.daysUntilStart}
            </Text>
          </View>
        </View>
      </View>

      {/* Success Milestones Progress */}
      <View style={styles.milestonesContainer}>
        <View style={styles.milestonesHeader}>
          <MaterialCommunityIcons name="flag-checkered" size={18} color="#10B981" />
          <Text style={styles.milestonesTitle}>Success Milestones</Text>
          <Text style={styles.milestonesProgress}>
            {item.milestonesCompleted} of {item.totalMilestones} completed
          </Text>
        </View>
        
        {/* Milestones List */}
        <View style={styles.milestonesList}>
          {successMilestones.map((milestone, index) => {
            const isCompleted = (item.completedMilestones || []).includes(milestone.id);
            return (
              <View key={milestone.id} style={styles.milestoneItem}>
                <MaterialCommunityIcons
                  name={isCompleted ? 'check-circle' : 'clock-outline'}
                  size={16}
                  color={isCompleted ? milestone.color : '#D1D5DB'}
                />
                <Text style={[
                  styles.milestoneText,
                  { color: isCompleted ? '#374151' : '#9CA3AF' }
                ]}>
                  {milestone.name}
                </Text>
              </View>
            );
          })}
        </View>
      </View>

      {/* Start Date & Onboarding Info */}
      <View style={styles.startDateContainer}>
        <View style={styles.startDateHeader}>
          <MaterialCommunityIcons name="calendar-start" size={18} color="#3B82F6" />
          <Text style={styles.startDateTitle}>Start Date & Onboarding</Text>
        </View>
        
        <View style={styles.startDateDetails}>
          <View style={styles.startDateItem}>
            <MaterialCommunityIcons name="calendar" size={16} color="#3B82F6" />
            <Text style={styles.startDateLabel}>Start Date:</Text>
            <Text style={[
              styles.startDateValue,
              { color: item.daysUntilStart <= 7 ? '#EF4444' : '#374151' }
            ]}>
              {formatDate(item.startDate)} ({item.daysUntilStart} days)
            </Text>
          </View>
          <View style={styles.startDateItem}>
            <MaterialCommunityIcons name="account-tie" size={16} color="#8B5CF6" />
            <Text style={styles.startDateLabel}>Manager:</Text>
            <Text style={styles.startDateValue}>{item.onboardingManager}</Text>
          </View>
          <View style={styles.startDateItem}>
            <MaterialCommunityIcons name="account-heart" size={16} color="#10B981" />
            <Text style={styles.startDateLabel}>Buddy:</Text>
            <Text style={styles.startDateValue}>{item.onboardingBuddy}</Text>
          </View>
          <View style={styles.startDateItem}>
            <MaterialCommunityIcons name="office-building" size={16} color="#F59E0B" />
            <Text style={styles.startDateLabel}>Setup:</Text>
            <Text style={styles.startDateValue}>{item.workSetup} • {item.deskLocation}</Text>
          </View>
        </View>
      </View>

      {/* Smart Contract Status */}
      <View style={styles.smartContractContainer}>
        <View style={styles.smartContractHeader}>
          <MaterialCommunityIcons name="file-document-check" size={18} color="#8B5CF6" />
          <Text style={styles.smartContractTitle}>Smart Contract Status</Text>
          <View style={styles.contractVerifiedBadge}>
            <MaterialCommunityIcons name="shield-check" size={12} color="#FFFFFF" />
            <Text style={styles.contractVerifiedText}>VERIFIED</Text>
          </View>
        </View>
        
        <View style={styles.contractDetails}>
          <View style={styles.contractDetail}>
            <MaterialCommunityIcons name="link" size={14} color="#8B5CF6" />
            <Text style={styles.contractDetailLabel}>Contract Address:</Text>
            <Text style={styles.contractAddress}>{(item.smartContractAddress || '').substring(0, 10)}...</Text>
          </View>
          <View style={styles.contractDetail}>
            <MaterialCommunityIcons name="file-code" size={14} color="#8B5CF6" />
            <Text style={styles.contractDetailLabel}>Version:</Text>
            <Text style={styles.contractVersion}>{item.contractVersion}</Text>
          </View>
          <View style={styles.contractDetail}>
            <MaterialCommunityIcons name="calendar-check" size={14} color="#10B981" />
            <Text style={styles.contractDetailLabel}>Signed:</Text>
            <Text style={styles.contractSignedDate}>{formatDate(item.contractSignedDate)}</Text>
          </View>
        </View>
      </View>

      {/* Pre-boarding Activities */}
      <View style={styles.preBoardingContainer}>
        <View style={styles.preBoardingHeader}>
          <MaterialCommunityIcons name="clipboard-check" size={18} color="#F59E0B" />
          <Text style={styles.preBoardingTitle}>Pre-boarding Activities</Text>
          <Text style={styles.preBoardingProgress}>
            {item.preBoardingCompleted}/{(item.preBoardingActivities || []).length} completed
          </Text>
        </View>
        
        <View style={styles.preBoardingActivities}>
          {(item.preBoardingActivities || []).map((activity, index) => (
            <View key={activity.id} style={styles.preBoardingActivity}>
              <MaterialCommunityIcons
                name={activity.completed ? 'check-circle' : 'clock-outline'}
                size={14}
                color={activity.completed ? '#10B981' : '#F59E0B'}
              />
              <Text style={[
                styles.preBoardingActivityText,
                { color: activity.completed ? '#374151' : '#6B7280' }
              ]}>
                {activity.name}
              </Text>
            </View>
          ))}
        </View>
      </View>

      {/* Equipment & Setup Status */}
      <View style={styles.equipmentContainer}>
        <View style={styles.equipmentHeader}>
          <MaterialCommunityIcons name="laptop" size={18} color="#EF4444" />
          <Text style={styles.equipmentTitle}>Equipment & Setup</Text>
        </View>
        
        <View style={styles.equipmentDetails}>
          <View style={styles.equipmentItem}>
            <Text style={styles.equipmentPackage}>{item.equipmentPackage}</Text>
            <View style={styles.equipmentStatus}>
              <MaterialCommunityIcons 
                name={item.equipmentOrdered ? 'check-circle' : 'clock-outline'} 
                size={14} 
                color={item.equipmentOrdered ? '#10B981' : '#F59E0B'} 
              />
              <Text style={styles.equipmentStatusText}>
                <Text>{item.equipmentOrdered ? 'Ordered' : 'Pending'}</Text>
              </Text>
            </View>
          </View>
          
          <View style={styles.setupItems}>
            <View style={styles.setupItem}>
              <MaterialCommunityIcons 
                name={item.accountsCreated ? 'check-circle' : 'clock-outline'} 
                size={12} 
                color={item.accountsCreated ? '#10B981' : '#F59E0B'} 
              />
              <Text style={styles.setupItemText}>Accounts Created</Text>
            </View>
            <View style={styles.setupItem}>
              <MaterialCommunityIcons 
                name={item.accessGranted ? 'check-circle' : 'clock-outline'} 
                size={12} 
                color={item.accessGranted ? '#10B981' : '#F59E0B'} 
              />
              <Text style={styles.setupItemText}>Access Granted</Text>
            </View>
            <View style={styles.setupItem}>
              <MaterialCommunityIcons 
                name={item.benefitsEnrolled ? 'check-circle' : 'clock-outline'} 
                size={12} 
                color={item.benefitsEnrolled ? '#10B981' : '#F59E0B'} 
              />
              <Text style={styles.setupItemText}>Benefits Enrolled</Text>
            </View>
          </View>
        </View>
      </View>

      {/* Background Check Status */}
      <View style={styles.backgroundCheckContainer}>
        <View style={styles.backgroundCheckHeader}>
          <MaterialCommunityIcons name="shield-check" size={16} color="#3B82F6" />
          <Text style={styles.backgroundCheckTitle}>Background Check</Text>
          <View style={[
            styles.backgroundCheckStatusBadge,
            { backgroundColor: item.backgroundCheckStatus === 'Completed' ? '#10B981' : '#F59E0B' }
          ]}>
            <Text style={styles.backgroundCheckStatusText}>{item.backgroundCheckStatus}</Text>
          </View>
        </View>
        
        {item.backgroundCheckStatus === 'Completed' && (
          <View style={styles.backgroundCheckDetails}>
            <View style={styles.backgroundCheckItem}>
              <MaterialCommunityIcons 
                name={item.referencesVerified ? 'check-circle' : 'close-circle'} 
                size={12} 
                color={item.referencesVerified ? '#10B981' : '#EF4444'} 
              />
              <Text style={styles.backgroundCheckItemText}>References</Text>
            </View>
            <View style={styles.backgroundCheckItem}>
              <MaterialCommunityIcons 
                name={item.criminalCheckClear ? 'check-circle' : 'close-circle'} 
                size={12} 
                color={item.criminalCheckClear ? '#10B981' : '#EF4444'} 
              />
              <Text style={styles.backgroundCheckItemText}>Criminal Check</Text>
            </View>
            <View style={styles.backgroundCheckItem}>
              <MaterialCommunityIcons 
                name={item.educationVerified ? 'check-circle' : 'close-circle'} 
                size={12} 
                color={item.educationVerified ? '#10B981' : '#EF4444'} 
              />
              <Text style={styles.backgroundCheckItemText}>Education</Text>
            </View>
          </View>
        )}
      </View>

      {/* Success & Risk Factors */}
      {((item.successFactors || []).length > 0 || (item.riskFactors || []).length > 0) && (
        <View style={styles.factorsContainer}>
          {(item.successFactors || []).length > 0 && (
            <View style={styles.successFactors}>
              <Text style={styles.factorsTitle}>Success Factors:</Text>
              <View style={styles.factorsList}>
                {(item.successFactors || []).map((factor, index) => (
                  <View key={index} style={styles.successFactor}>
                    <MaterialCommunityIcons name="check-circle" size={12} color="#10B981" />
                    <Text style={styles.successFactorText}>{factor}</Text>
                  </View>
                ))}
              </View>
            </View>
          )}
          
          {(item.riskFactors || []).length > 0 && (
            <View style={styles.riskFactors}>
              <Text style={styles.factorsTitle}>Risk Factors:</Text>
              <View style={styles.factorsList}>
                {(item.riskFactors || []).map((factor, index) => (
                  <View key={index} style={styles.riskFactor}>
                    <MaterialCommunityIcons name="alert-circle" size={12} color="#EF4444" />
                    <Text style={styles.riskFactorText}>{factor}</Text>
                  </View>
                ))}
              </View>
            </View>
          )}
        </View>
      )}

      {/* Previous Performance Summary */}
      <View style={styles.previousPerformanceContainer}>
        <Text style={styles.previousPerformanceTitle}>Applicant Performance</Text>
        <View style={styles.performanceMetrics}>
          <View style={styles.performanceMetric}>
            <Text style={styles.performanceLabel}>Final Interview</Text>
            <Text style={styles.performanceValue}>{item.finalInterviewScore}%</Text>
          </View>
          <View style={styles.performanceMetric}>
            <Text style={styles.performanceLabel}>AR Demo</Text>
            <Text style={styles.performanceValue}>{item.arDemoScore}%</Text>
          </View>
          <View style={styles.performanceMetric}>
            <Text style={styles.performanceLabel}>Overall Rating</Text>
            <View style={styles.starsContainer}>
              {renderStars(item.overallRating)}
            </View>
          </View>
          <View style={styles.performanceMetric}>
            <Text style={styles.performanceLabel}>Package Value</Text>
            <Text style={styles.performanceValue}>{formatCurrency(item.totalPackage)}</Text>
          </View>
        </View>
      </View>

      {/* Actions */}
      <View style={styles.applicantActions}>
        {/* Contract actions — stage-aware. Just-accepted → Send Contract.
            Already sent → Preview + Mark Signed. Already signed → no
            contract action (proceed to background / onboarding instead). */}
        {item.acceptanceStatus === 'accepted' && (
          <>
            <TouchableOpacity
              style={[styles.actionButton, { backgroundColor: '#8B5CF6' }]}
              onPress={() => sendContract(item)}
            >
              <MaterialCommunityIcons name="file-send" size={16} color="#FFFFFF" />
              <Text style={[styles.actionButtonText, { color: '#FFFFFF' }]}>Send Contract</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.actionButton, { backgroundColor: '#FFFFFF', borderWidth: 1.5, borderColor: '#0e4e96' }]}
              onPress={() => previewContract(item)}
            >
              <MaterialCommunityIcons name="file-pdf-box" size={16} color="#0e4e96" />
              <Text style={[styles.actionButtonText, { color: '#0e4e96' }]}>Preview Contract</Text>
            </TouchableOpacity>
          </>
        )}
        {item.acceptanceStatus === 'contract_sent' && (
          <>
            <TouchableOpacity
              style={[styles.actionButton, { backgroundColor: '#10B981' }]}
              onPress={() => markContractSigned(item)}
            >
              <MaterialCommunityIcons name="file-sign" size={16} color="#FFFFFF" />
              <Text style={[styles.actionButtonText, { color: '#FFFFFF' }]}>Mark Signed</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.actionButton, { backgroundColor: '#FFFFFF', borderWidth: 1.5, borderColor: '#8B5CF6' }]}
              onPress={() => sendContract(item)}
            >
              <MaterialCommunityIcons name="email-fast-outline" size={16} color="#8B5CF6" />
              <Text style={[styles.actionButtonText, { color: '#8B5CF6' }]}>Resend</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.actionButton, { backgroundColor: '#FFFFFF', borderWidth: 1.5, borderColor: '#0e4e96' }]}
              onPress={() => previewContract(item)}
            >
              <MaterialCommunityIcons name="file-pdf-box" size={16} color="#0e4e96" />
              <Text style={[styles.actionButtonText, { color: '#0e4e96' }]}>Preview</Text>
            </TouchableOpacity>
          </>
        )}
        {item.acceptanceStatus === 'contract_signed' && (
          <TouchableOpacity
            style={[styles.actionButton, { backgroundColor: '#FFFFFF', borderWidth: 1.5, borderColor: '#10B981' }]}
            onPress={() => previewContract(item)}
          >
            <MaterialCommunityIcons name="file-document-check" size={16} color="#10B981" />
            <Text style={[styles.actionButtonText, { color: '#10B981' }]}>View Signed Contract</Text>
          </TouchableOpacity>
        )}
        {item.acceptanceStatus === 'onboarding_ready' && (
          <TouchableOpacity
            style={[styles.actionButton, { backgroundColor: '#F59E0B' }]}
            onPress={() => handleStartOnboarding(item)}
          >
            <MaterialCommunityIcons name="school" size={16} color="#FFFFFF" />
            <Text style={[styles.actionButtonText, { color: '#FFFFFF' }]}>Start Onboarding</Text>
          </TouchableOpacity>
        )}
        {item.daysUntilStart <= 7 && (
          <TouchableOpacity
            style={[styles.actionButton, { backgroundColor: '#3B82F6' }]}
            onPress={() => handleScheduleFirstDay(item)}
          >
            <MaterialCommunityIcons name="calendar-plus" size={16} color="#FFFFFF" />
            <Text style={[styles.actionButtonText, { color: '#FFFFFF' }]}>Schedule First Day</Text>
          </TouchableOpacity>
        )}
        {/* Move to Hired — final pipeline step. Visible on every accepted
            offer card so the recruiter can promote them when ready (after
            background check, contract signed, onboarding scheduled, etc).
            Click triggers job_offers→hired, applicant stage→hired, and
            creates the employees row that HiredScreen reads. */}
        <TouchableOpacity
          style={[styles.actionButton, { backgroundColor: '#10B981' }]}
          onPress={() => handleMoveToHired(item)}
        >
          <MaterialCommunityIcons name="briefcase-check" size={16} color="#FFFFFF" />
          <Text style={[styles.actionButtonText, { color: '#FFFFFF' }]}>Move to Hired</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.actionButton}
          onPress={() => navigation.navigate('AcceptedOfferDetailsScreen', { applicant: item, companyLogo, companyName })}
        >
          <MaterialCommunityIcons name="eye" size={16} color="#10B981" />
          <Text style={styles.actionButtonText}>View Details</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.moreButton}
          onPress={() => {
            Alert.alert(
              'Accepted Offer Actions',
              'Choose an action',
              [
                { text: 'Contact Applicant', onPress: () => console.log('Contact applicant') },
                { text: 'Update Onboarding', onPress: () => console.log('Update onboarding') },
                { text: 'View Contract', onPress: () => console.log('View contract') },
                { text: 'Cancel', style: 'cancel' },
              ]
            );
          }}
        >
          <MaterialCommunityIcons name="dots-vertical" size={20} color="#6B7280" />
        </TouchableOpacity>
      </View>
    </TouchableOpacity>
  );

  if (isLoading) {
    return (
      <SafeAreaView style={styles.container}>
        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#10B981" />
          <Text style={styles.loadingText}>Loading accepted offers...</Text>
        </View>
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="light-content" backgroundColor="#10B981" />
      
      {/* Header */}
      <LinearGradient
        colors={['#10B981', '#059669']}
        style={styles.header}
      >
        <View style={styles.headerContent}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => navigation.goBack()}
          >
            <MaterialCommunityIcons name="arrow-left" size={24} color="#FFFFFF" />
          </TouchableOpacity>
          
          <View style={styles.headerInfo}>
            <View style={styles.headerTitleContainer}>
              {companyLogo ? <Image source={{ uri: companyLogo || undefined }} style={{ width: 24, height: 24, borderRadius: 12 }} /> : <MaterialCommunityIcons name="check-circle" size={24} color="#FFFFFF" />}
              <Text style={styles.headerTitle}>Accepted Offers</Text>
            </View>
            <Text style={styles.headerSubtitle}>
              {sortedApplicants.length} Applicants • Success
            </Text>
          </View>
          
          <TouchableOpacity
            style={styles.successButton}
            onPress={() => setShowSuccessModal(true)}
          >
            <MaterialCommunityIcons name="trending-up" size={24} color="#FFFFFF" />
          </TouchableOpacity>
        </View>
      </LinearGradient>

      {/* Search and Sort */}
      <View style={styles.searchSortContainer}>
        <View style={styles.searchBar}>
          <MaterialCommunityIcons name="magnify" size={20} color="#6B7280" />
          <TextInput
            style={styles.searchInput}
            placeholder="Search accepted offers..."
            value={searchQuery}
            onChangeText={setSearchQuery}
            placeholderTextColor="#9CA3AF"
          />
        </View>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          style={styles.sortContainer}
        >
          {sortOptions.map((option) => (
            <TouchableOpacity
              key={option.id}
              style={[
                styles.sortOption,
                sortBy === option.id && styles.activeSortOption,
              ]}
              onPress={() => setSortBy(option.id)}
            >
              <MaterialCommunityIcons
                name={option.icon}
                size={16}
                color={sortBy === option.id ? '#FFFFFF' : '#6B7280'}
              />
              <Text
                style={[
                  styles.sortOptionText,
                  sortBy === option.id && styles.activeSortOptionText,
                ]}
              >
                {option.name}
              </Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>

      {/* Tabs */}
      <View style={styles.tabsContainer}>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={styles.tabsContent}
        >
          {tabs.map((tab) => (
            <TouchableOpacity
              key={tab.id}
              style={[
                styles.tab,
                selectedTab === tab.id && styles.activeTab,
              ]}
              onPress={() => setSelectedTab(tab.id)}
            >
              <Text
                style={[
                  styles.tabText,
                  selectedTab === tab.id && styles.activeTabText,
                ]}
              >
                {tab.name}
              </Text>
              <View
                style={[
                  styles.tabBadge,
                  selectedTab === tab.id && styles.activeTabBadge,
                ]}
              >
                <Text
                  style={[
                    styles.tabBadgeText,
                    selectedTab === tab.id && styles.activeTabBadgeText,
                  ]}
                >
                  {tab.count}
                </Text>
              </View>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>

      {/* Bulk Actions */}
      {selectedApplicants.length > 0 && (
        <View style={styles.bulkActionsContainer}>
          <Text style={styles.bulkActionsText}>
            {selectedApplicants.length} selected
          </Text>
          <View style={styles.bulkActions}>
            <TouchableOpacity
              style={styles.bulkActionButton}
              onPress={() => console.log('Bulk onboarding')}
            >
              <MaterialCommunityIcons name="school" size={16} color="#FFFFFF" />
              <Text style={styles.bulkActionText}>Start Onboarding</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.bulkActionButton, { backgroundColor: '#3B82F6' }]}
              onPress={() => handleBulkAction('Move to Hired')}
            >
              <MaterialCommunityIcons name="arrow-right" size={16} color="#FFFFFF" />
              <Text style={styles.bulkActionText}>Move to Hired</Text>
            </TouchableOpacity>
          </View>
        </View>
      )}

      {/* Applicants List */}
      <FlatList
        data={sortedApplicants}
        keyExtractor={(item) => item.id}
        renderItem={renderApplicantCard}
        style={styles.applicantsList}
        contentContainerStyle={styles.applicantsListContent}
        showsVerticalScrollIndicator={false}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
        }
        ListEmptyComponent={() => (
          <View style={styles.emptyContainer}>
            <MaterialCommunityIcons name="check-circle-outline" size={64} color="#D1D5DB" />
            <Text style={styles.emptyTitle}>No accepted offers found</Text>
            <Text style={styles.emptySubtitle}>
              {searchQuery
                ? 'Try adjusting your search criteria'
                : 'No offers match the current criteria'}
            </Text>
          </View>
        )}
      />

      {/* Floating Action Button */}
      <TouchableOpacity
        style={styles.fab}
        onPress={() => navigation.navigate('HiredScreen', { companyLogo, companyName,
          totalHired: sortedApplicants.filter(c => c.acceptanceStatus === 'onboarding_ready').length,
        })}
      >
        <MaterialCommunityIcons name="arrow-right" size={24} color="#FFFFFF" />
      </TouchableOpacity>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#667eea',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: '#6B7280',
  },
  header: {
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 20,
  },
  headerContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  backButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerInfo: {
    flex: 1,
    alignItems: 'center',
  },
  headerTitleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#FFFFFF',
    marginLeft: 8,
  },
  headerSubtitle: {
    fontSize: 14,
    color: 'rgba(255, 255, 255, 0.8)',
    marginTop: 4,
  },
  successButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  searchSortContainer: {
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  searchBar: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F3F4F6',
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginBottom: 12,
  },
  searchInput: {
    flex: 1,
    marginLeft: 12,
    fontSize: 16,
    color: '#1F2937',
  },
  sortContainer: {
    flexDirection: 'row',
  },
  sortOption: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8,
    marginRight: 8,
    borderRadius: 16,
    backgroundColor: '#F3F4F6',
  },
  activeSortOption: {
    backgroundColor: '#10B981',
  },
  sortOptionText: {
    marginLeft: 4,
    fontSize: 12,
    color: '#6B7280',
    fontWeight: '500',
  },
  activeSortOptionText: {
    color: '#FFFFFF',
  },
  tabsContainer: {
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  tabsContent: {
    paddingHorizontal: 20,
  },
  tab: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginRight: 8,
    borderRadius: 20,
    backgroundColor: '#F3F4F6',
  },
  activeTab: {
    backgroundColor: '#D1FAE5',
  },
  tabText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#6B7280',
  },
  activeTabText: {
    color: '#10B981',
  },
  tabBadge: {
    marginLeft: 8,
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 10,
    backgroundColor: '#E5E7EB',
  },
  activeTabBadge: {
    backgroundColor: '#10B981',
  },
  tabBadgeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#6B7280',
  },
  activeTabBadgeText: {
    color: '#FFFFFF',
  },
  bulkActionsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#10B981',
    paddingHorizontal: 20,
    paddingVertical: 12,
  },
  bulkActionsText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  bulkActions: {
    flexDirection: 'row',
  },
  bulkActionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F59E0B',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    marginLeft: 8,
  },
  bulkActionText: {
    marginLeft: 4,
    fontSize: 12,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  applicantsList: {
    flex: 1,
  },
  applicantsListContent: {
    padding: 20,
  },
  applicantCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  selectedCard: {
    borderWidth: 2,
    borderColor: '#10B981',
  },
  checkbox: {
    position: 'absolute',
    top: 12,
    right: 12,
    zIndex: 1,
  },
  applicantHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 16,
  },
  avatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
    marginRight: 12,
  },
  applicantInfo: {
    flex: 1,
  },
  applicantNameContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: 4,
  },
  applicantName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1F2937',
    marginRight: 8,
  },
  applicantBadges: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  tagBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 6,
    paddingVertical: 2,
    backgroundColor: '#D1FAE5',
    borderRadius: 8,
    marginRight: 4,
    marginBottom: 2,
  },
  tagText: {
    marginLeft: 2,
    fontSize: 10,
    fontWeight: '600',
    color: '#10B981',
  },
  applicantPosition: {
    fontSize: 14,
    fontWeight: '500',
    color: '#374151',
    marginBottom: 2,
  },
  applicantCompany: {
    fontSize: 12,
    color: '#6B7280',
  },
  applicantStatus: {
    alignItems: 'flex-end',
  },
  statusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  statusText: {
    fontSize: 10,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  successMetricsContainer: {
    backgroundColor: '#D1FAE5',
    borderRadius: 12,
    padding: 12,
    marginBottom: 12,
    borderLeftWidth: 4,
    borderLeftColor: '#10B981',
  },
  successMetricsHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  successMetricsTitle: {
    flex: 1,
    marginLeft: 8,
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
  },
  successScoreBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    backgroundColor: '#10B981',
    borderRadius: 12,
  },
  successScoreText: {
    fontSize: 12,
    fontWeight: '700',
    color: '#FFFFFF',
  },
  metricsGrid: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 8,
  },
  metricItem: {
    alignItems: 'center',
  },
  metricLabel: {
    fontSize: 10,
    color: '#6B7280',
    marginTop: 2,
  },
  metricValue: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#1F2937',
    marginTop: 2,
  },
  milestonesContainer: {
    backgroundColor: '#F0FDF4',
    borderRadius: 12,
    padding: 12,
    marginBottom: 12,
  },
  milestonesHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  milestonesTitle: {
    flex: 1,
    marginLeft: 8,
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
  },
  milestonesProgress: {
    fontSize: 12,
    color: '#10B981',
    fontWeight: '600',
  },
  milestonesList: {
    marginTop: 4,
  },
  milestoneItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  milestoneText: {
    marginLeft: 8,
    fontSize: 12,
    fontWeight: '500',
  },
  startDateContainer: {
    backgroundColor: '#EFF6FF',
    borderRadius: 12,
    padding: 12,
    marginBottom: 12,
  },
  startDateHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  startDateTitle: {
    marginLeft: 8,
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
  },
  startDateDetails: {
    marginTop: 4,
  },
  startDateItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  startDateLabel: {
    marginLeft: 8,
    fontSize: 12,
    color: '#6B7280',
    width: 70,
  },
  startDateValue: {
    fontSize: 12,
    color: '#374151',
    fontWeight: '500',
  },
  smartContractContainer: {
    backgroundColor: '#F8FAFC',
    borderRadius: 12,
    padding: 12,
    marginBottom: 12,
    borderLeftWidth: 4,
    borderLeftColor: '#8B5CF6',
  },
  smartContractHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  smartContractTitle: {
    flex: 1,
    marginLeft: 8,
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
  },
  contractVerifiedBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingVertical: 4,
    backgroundColor: '#8B5CF6',
    borderRadius: 12,
  },
  contractVerifiedText: {
    marginLeft: 4,
    fontSize: 10,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  contractDetails: {
    marginTop: 4,
  },
  contractDetail: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  contractDetailLabel: {
    marginLeft: 4,
    fontSize: 11,
    color: '#6B7280',
    width: 100,
  },
  contractAddress: {
    fontSize: 11,
    fontFamily: 'monospace',
    color: '#8B5CF6',
    fontWeight: '600',
  },
  contractVersion: {
    fontSize: 11,
    color: '#8B5CF6',
    fontWeight: '600',
  },
  contractSignedDate: {
    fontSize: 11,
    color: '#10B981',
    fontWeight: '500',
  },
  preBoardingContainer: {
    backgroundColor: '#FEF3E2',
    borderRadius: 12,
    padding: 12,
    marginBottom: 12,
  },
  preBoardingHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  preBoardingTitle: {
    flex: 1,
    marginLeft: 8,
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
  },
  preBoardingProgress: {
    fontSize: 12,
    color: '#F59E0B',
    fontWeight: '600',
  },
  preBoardingActivities: {
    marginTop: 4,
  },
  preBoardingActivity: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  preBoardingActivityText: {
    marginLeft: 8,
    fontSize: 12,
    fontWeight: '500',
  },
  equipmentContainer: {
    backgroundColor: '#FEF2F2',
    borderRadius: 12,
    padding: 12,
    marginBottom: 12,
  },
  equipmentHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  equipmentTitle: {
    marginLeft: 8,
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
  },
  equipmentDetails: {
    marginTop: 4,
  },
  equipmentItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  equipmentPackage: {
    fontSize: 13,
    fontWeight: '600',
    color: '#1F2937',
  },
  equipmentStatus: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  equipmentStatusText: {
    marginLeft: 4,
    fontSize: 12,
    color: '#6B7280',
  },
  setupItems: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  setupItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
    marginBottom: 4,
  },
  setupItemText: {
    marginLeft: 4,
    fontSize: 11,
    color: '#6B7280',
  },
  backgroundCheckContainer: {
    backgroundColor: '#F9FAFB',
    borderRadius: 12,
    padding: 12,
    marginBottom: 12,
  },
  backgroundCheckHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  backgroundCheckTitle: {
    flex: 1,
    marginLeft: 8,
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
  },
  backgroundCheckStatusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  backgroundCheckStatusText: {
    fontSize: 10,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  backgroundCheckDetails: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 4,
  },
  backgroundCheckItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
    marginBottom: 4,
  },
  backgroundCheckItemText: {
    marginLeft: 4,
    fontSize: 11,
    color: '#6B7280',
  },
  factorsContainer: {
    marginBottom: 12,
  },
  successFactors: {
    marginBottom: 8,
  },
  riskFactors: {
    marginBottom: 4,
  },
  factorsTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: '#374151',
    marginBottom: 4,
  },
  factorsList: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  successFactor: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 6,
    paddingVertical: 2,
    backgroundColor: '#D1FAE5',
    borderRadius: 8,
    marginRight: 4,
    marginBottom: 2,
  },
  successFactorText: {
    marginLeft: 2,
    fontSize: 10,
    color: '#10B981',
  },
  riskFactor: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 6,
    paddingVertical: 2,
    backgroundColor: '#FEE2E2',
    borderRadius: 8,
    marginRight: 4,
    marginBottom: 2,
  },
  riskFactorText: {
    marginLeft: 2,
    fontSize: 10,
    color: '#EF4444',
  },
  previousPerformanceContainer: {
    backgroundColor: '#F9FAFB',
    borderRadius: 12,
    padding: 12,
    marginBottom: 12,
  },
  previousPerformanceTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
    marginBottom: 8,
  },
  performanceMetrics: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  performanceMetric: {
    alignItems: 'center',
  },
  performanceLabel: {
    fontSize: 10,
    color: '#6B7280',
  },
  performanceValue: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#10B981',
    marginTop: 2,
  },
  starsContainer: {
    flexDirection: 'row',
    marginTop: 2,
  },
  applicantActions: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  actionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingVertical: 6,
    backgroundColor: '#F3F4F6',
    borderRadius: 12,
    marginRight: 8,
    marginBottom: 4,
  },
  actionButtonText: {
    marginLeft: 4,
    fontSize: 11,
    color: '#6B7280',
    fontWeight: '500',
  },
  moreButton: {
    padding: 6,
    marginLeft: 'auto',
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 60,
  },
  emptyTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#374151',
    marginTop: 16,
    marginBottom: 8,
  },
  emptySubtitle: {
    fontSize: 14,
    color: '#6B7280',
    textAlign: 'center',
    paddingHorizontal: 40,
  },
  fab: {
    position: 'absolute',
    bottom: 30,
    right: 30,
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: '#10B981',
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 8,
  },
});
